/**
 * Shows the element only if the logged user has access to a state.
 *
 * Behaves exactly like ngIf.
 *
 * @example <div tmr-if-access="'app.operations.inbound'"></div>
 *
 * @namespace
 * @alias tmrIfAccess
 * @type {ngDirective}
 */
function tmrIfAccessDirective($parse, ngIfDirective, UserStorage) {
  'ngInject'
  return (({
    multiElement,
    transclude,
    terminal,
    restrict,
    $$tlb,
    priority,
  }) => ({
    multiElement,
    transclude,
    terminal,
    restrict,
    $$tlb,
    priority: priority + 1,
    link,
  }))(ngIfDirective[0])

  function link($scope, $element, $attr) {
    let state = $parse($attr.tmrIfAccess)($scope)
    let hasAccess = UserStorage.access(state).toString()
    // Support chaining condition with an ngIf in the same element.
    $attr.ngIf = $attr.ngIf ? `(${$attr.ngIf}) && ${hasAccess}` : hasAccess
    ngIfDirective[0].link.apply(this, arguments)
  }
}

export const directive = ['tmrIfAccess', tmrIfAccessDirective]
